import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import 'assets/vendor/nucleo/css/nucleo.css';
import 'assets/vendor/font-awesome/css/font-awesome.min.css';
import 'assets/scss/argon-design-system-react.scss?v1.1.0';
import './custom.css';

import Index from './pages/Home/Index';
import Login from './pages/Login/Login';

//admin
import MediaAdmin from './pages/Media_admin/Index';
import TambahBeritaA from './pages/Media_admin/TambahBerita';
import EdithBeritaA from './pages/Media_admin/EditBerita';
// import Penduduk from './pages/Penduduk/Index';
// import TambahPenduduk from './pages/Penduduk/TambahPenduduk';
// import EditPenduduk from './pages/Penduduk/EditPenduduk';
// import PendudukProfil from './pages/Penduduk/Profile';
// import VerifikasiKK from './pages/Verifikasi/kartuKeluarga';
// import AparaturList from './pages/Aparatur/AparaturList';
// import TambahSlider from './pages/Media_admin/TambahSlider';

ReactDOM.render(
	<BrowserRouter>
		<Switch>
			<Route path="/" exact render={(props) => <Index {...props} />} />
			<Route path="/masuk" exact render={(props) => <Login {...props} />} />
			<Route path="/admin/media" exact render={(props) => <MediaAdmin {...props} />} />
			<Route path="/admin/tambah-data" exact render={(props) => <TambahBeritaA {...props} />} />
			<Route path="/admin/edit-data" exact render={(props) => <EdithBeritaA {...props} />} />
			{/* <Route path="/admin/tambah-slider" exact render={(props) => <TambahSlider {...props} />} />
			<Route path="/penduduk" exact render={(props) => <Penduduk {...props} />} />
			<Route path="/penduduk/tambah" exact render={(props) => <TambahPenduduk {...props} />} />
			<Route path="/penduduk/edit/:email" exact render={(props) => <EditPenduduk {...props} />} />
			<Route path="/penduduk/profil/:email" exact render={(props) => <PendudukProfil {...props} />} />
			<Route path="/verifikasikk/:nokk" exact render={(props) => <VerifikasiKK {...props} />} />

			<Route path="/aparatur" exact render={(props) => <AparaturList {...props} />} /> */}

			<Redirect to="/" />
		</Switch>
	</BrowserRouter>,
	document.getElementById('root')
);
